import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Theme from 'LegacyWeployDesignLanguage/Theme';

import MaterialPaper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    margin: `${Theme.space.single} 0`,
    padding: Theme.space.single,
  },
});

const propTypes = {
  error: PropTypes.bool,
  height: PropTypes.string,
};

const defaultProps = {
  error: false,
  height: 'none',
};

// Card is deprecated, please use Paper instead
const Card = styled.div`
  border-radius: 5px;
  margin: ${props => props.theme.space.single} 0;
  padding: ${props => props.theme.space.single};
  box-shadow: 0 2px 3px ${props => props.theme.colors.shadow}, 0 0 0 1px ${props => props.theme.colors.shadow};
  height: ${props => props.height};

  ${props => props.error && css`
    box-shadow: 0 2px 3px ${props.theme.colors.shadow}, 0 0 0 1px ${props.theme.colors.error};
  `};
`;

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

const Paper = withStyles(styles)(props => <MaterialPaper {...props} elevation={props.elevation || 1} />);

export { Card as default, Paper };
